import { createContext, useContext, useState, useEffect } from 'react';
import { authAPI } from '@/lib/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const savedUser = localStorage.getItem('user');
    
    if (token && savedUser) {
      setUser(JSON.parse(savedUser));
      // Verify token is still valid
      authAPI.me().catch(() => {
        logout();
      });
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    const res = await authAPI.login({ email, password });
    const { token, user } = res.data;
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(user));
    setUser(user);
    return user;
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
  };

  const updateUser = (partial) => {
    setUser((prev) => {
      const merged = { ...(prev || {}), ...(partial || {}) };
      try { localStorage.setItem('user', JSON.stringify(merged)); } catch { /* ignore */ }
      return merged;
    });
  };

  const isAdmin = () => user?.role === 'admin' || user?.role === 'master';
  const isTecnico = () => user?.role === 'tecnico';
  const isMaster = () => user?.role === 'master';

  return (
    <AuthContext.Provider value={{ user, login, logout, loading, isAdmin, isTecnico, isMaster, updateUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
}
